/* eslint-disable prettier/prettier */
// clioTokenManager.js

const TOKEN_KEY = "access_token_clio";
const EXPIRATION_KEY = "token_expiration_clio"; // store as timestamp in milliseconds

export const clioTokenManager = {
    setToken: (token, expiresInSeconds) => {

        localStorage.setItem(TOKEN_KEY, token);
        if (expiresInSeconds) {
            const expiration = Date.now() + expiresInSeconds * 1000; // convert to ms
            localStorage.setItem(EXPIRATION_KEY, expiration.toString());
        }

    },

    getToken: () => {
        if (clioTokenManager.isTokenExpired()) {
            clioTokenManager.clearToken();
            return null;
        }
        return localStorage.getItem(TOKEN_KEY);
    },

    isTokenExpired: () => {
        const expiration = parseInt(localStorage.getItem(EXPIRATION_KEY), 10);
        if (!expiration) return true;
        return Date.now() > expiration;
    },

    clearToken: () => {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(EXPIRATION_KEY);
    },
};
